<template>
  <el-dialog :title="currentView === 'list' ? '选择订单' : '选择费用'" :visible.sync="dialogVisible" width="900px"
    @close="handleClose" class="order-search-dialog">
    <!-- 订单列表视图 -->
    <div v-if="currentView === 'list'">
      <!-- 查询条件 -->
      <div class="search-form">
        <el-form :inline="true" :model="queryForm" size="small">
          <el-form-item label="委托单位">
            <el-select v-model="queryForm.company_id" filterable remote :remote-method="getCompanyList"
              placeholder="请选择委托单位" style="width: 220px" clearable @change="handleCompanyChange"
              :popper-append-to-body="false" popper-class="order-search-popper">
              <el-option v-for="item in companyList" :key="item.company_id" :label="item.name_zh || item.name_en"
                :value="item.company_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务编号">
            <el-input v-model="queryForm.order_no" placeholder="请输入业务编号" style="width: 180px"></el-input>
          </el-form-item>
          <el-form-item label="目的港">
            <portSelect v-model="queryForm.dest_port" placeTitle="港口名称或代码" :width="'180px'" clearable
              ref="portSelectRef" @input="dest_port_input" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" :loading="loading">查 询</el-button>
            <el-button @click="resetQuery">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 订单列表 -->
      <div class="tableBlock">
        <el-table :data="orderList" style="width: 100%" v-loading="loading" border fit height="400px">
          <el-table-column prop="order_id" width="0" v-if="false"></el-table-column>
          <el-table-column label="业务编号" prop="job_no" min-width="16%" show-overflow-tooltip></el-table-column>
          <el-table-column label="目的港" prop="pod_name" min-width="22%" show-overflow-tooltip></el-table-column>
          <el-table-column label="委托单位" prop="customer_name" min-width="30%" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="船公司" prop="shipping_company" min-width="22%" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="90" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="selectOrder(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="paginationBlock">
        <el-pagination @current-change="handleChange" :page-size="10" layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 费用选择视图 -->
    <div v-else-if="currentView === 'fee'">
      <div class="fee-header">
        <span>请选择需要添加的费用</span>
        <el-button type="primary" size="small" plain @click="resetFeeSelection">重 置</el-button>
      </div>

      <div class="fee-content">
        <el-table ref="feeTable" :data="feeList" v-loading="feeLoading" style="width: 100%" border fit height="450px"
          @selection-change="handleFeeSelectionChange" :cell-style="{ padding: '2px 0', height: '32px' }"
          :row-style="{ height: '32px' }">
          <el-table-column type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column prop="fee_name" label="费用名称" min-width="20%" show-overflow-tooltip></el-table-column>
          <el-table-column label="国内/国外" min-width="15%" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.oversea == 2">国外</span>
              <span v-else-if="scope.row.oversea == 1">国内</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="currency_code" label="币种" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="measure_unit_name" label="计量单位" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="quantity" label="数量" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="unit_rate" label="应收单价" min-width="15%" show-overflow-tooltip></el-table-column>
          <el-table-column label="应收金额" min-width="15%" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.include_tax }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="backToList">取 消</el-button>
        <el-button type="primary" @click="confirmAddFees">添 加</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import portSelect from "~ymp/components/common/portSelect"

export default {
  name: "OrderSearchAdd",
  components: { portSelect },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      queryForm: {
        company_id: null,
        order_no: "",
        dest_port: ""
      },
      queryInfo: {
        dest_port_name: null,
        dest_port_id: null
      },
      companyName: "", // 存储当前选中的公司名称
      companyList: [], // 公司列表
      orderList: [],
      total: 0, // 总记录数
      currentPage: 1, // 当前页码
      selectedOrder: null,
      currentView: 'list', // 当前视图: 'list' 或 'fee'
      feeList: [],          // 费用列表
      selectedFees: [],     // 已选择的费用
      feeLoading: false,    // 费用加载状态
    };
  },
  methods: {
    // 目的港选择处理
    dest_port_input(val, name_en) {
      if (val === '') val = null
      let num = Number(val)
      if (!isNaN(num) || val === '') {
        this.queryInfo.dest_port_id = val
        this.queryInfo.dest_port_name = name_en
        // 更新查询表单中的dest_port以便搜索
        this.queryForm.dest_port = val
      }
    },

    // 打开弹窗
    open() {
      this.dialogVisible = true;
      this.resetQuery();
      
      // 确保订单列表为空
      this.orderList = [];
      this.total = 0;
    },

    // 处理公司选择变更
    handleCompanyChange(value) {
      if (value) {
        // 从列表中查找选中的公司
        const selectedCompany = this.companyList.find(item => item.company_id === value);
        if (selectedCompany) {
          this.companyName = selectedCompany.name_zh || selectedCompany.name_en;
        }
      } else {
        this.companyName = "";
      }
    },

    // 根据ID获取公司名称
    async getCompanyNameById(companyId) {
      if (!companyId) return;

      try {
        const res = await this.$store.dispatch("API_bookingSpace/company_detail", {
          company_id: companyId
        });

        if (res.success && res.data) {
          // 将公司添加到下拉列表，确保列表不为空
          const company = {
            company_id: companyId,
            name_zh: res.data.name_zh,
            name_en: res.data.name_en
          };

          this.companyName = company.name_zh || company.name_en;

          // 确保不重复添加
          if (!this.companyList.some(item => item.company_id === companyId)) {
            this.companyList.push(company);
          }
        }
      } catch (error) {
        console.error("获取公司详情失败:", error);
      }
    },

    // 获取公司列表用于下拉选择
    async getCompanyList(query) {
      if (query.length < 2 && query.length > 0) return;

      try {
        const params = {
          company_name: query,
          nopage: 0
        };

        const res = await this.$store.dispatch("API_bookingSpace/company_associateSearch", params);

        if (res.success) {
          this.companyList = res.data || [];
        } else {
          this.companyList = [];
        }
      } catch (error) {
        console.error("获取公司列表失败:", error);
        this.companyList = [];
      }
    },

    // 查询订单列表
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          limit: 10, // 每页显示10条
          start: this.currentPage - 1, // 页码从0开始计算
          job_no: this.queryForm.order_no,
          pod: this.queryInfo.dest_port_id,
          company_id: this.queryForm.company_id
        };

        const res = await this.$store.dispatch("API_bookingSpace/fba_order_list", params);

        if (res.success) {
          this.orderList = res.data || [];
          this.total = res.count || 0;
        } else {
          this.$message.error(res.message || "获取订单列表失败");
          this.orderList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("获取订单列表失败:", error);
        this.$message.error("获取订单列表失败，请稍后重试");
        this.orderList = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 重置查询条件
    resetQuery() {
      // 重置查询表单
      this.queryForm = {
        company_id: null,
        order_no: "",
        dest_port: ""
      };

      // 重置港口信息
      this.queryInfo = {
        dest_port_name: null,
        dest_port_id: null
      };

      // 重置其他相关状态
      this.companyName = "";
      this.currentPage = 1; // 重置页码为第一页
      this.companyList = []; // 清空公司列表

      // 使用 $nextTick 确保在下一个DOM更新周期执行
      this.$nextTick(() => {
        // 清空目的港选择器组件
        if (this.$refs.portSelectRef) {
          this.$refs.portSelectRef.selectClear(); // 调用组件的清空方法
        }
      });

      this.currentView = 'list'; // 确保重置时回到列表视图
    },

    // 查询
    handleSearch() {
      this.currentPage = 1;
      this.fetchOrderList();
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.currentView = 'list'; // 确保下次打开时为列表视图
      this.selectedFees = [];
    },

    // 处理页码变化
    handleChange(page) {
      this.currentPage = page;
      this.fetchOrderList();
    },

    // 选择订单并切换到费用视图
    async selectOrder(row) {
      this.selectedOrder = row;
      this.feeLoading = true;

      try {
        // 获取订单费用信息
        const res = await this.$store.dispatch("API_bookingSpace/fba_order_fee_list", {
          order_id: row.order_id
        });

        if (res.success) {
          this.feeList = res.data || [];
          // 切换到费用选择视图
          this.currentView = 'fee';
        } else {
          this.$message.error(res.message || "获取订单费用失败");
        }
      } catch (error) {
        console.error("获取订单费用失败:", error);
        this.$message.error("获取订单费用失败，请稍后重试");
      } finally {
        this.feeLoading = false;
      }
    },

    // 返回列表视图
    backToList() {
      this.currentView = 'list';
      this.selectedFees = [];
      // 清除表格的选择状态
      if (this.$refs.feeTable) {
        this.$refs.feeTable.clearSelection();
      }
    },

    // 重置费用选择
    resetFeeSelection() {
      this.selectedFees = [];
      if (this.$refs.feeTable) {
        this.$refs.feeTable.clearSelection();
      }
    },

    // 处理费用表格选择变化
    handleFeeSelectionChange(selection) {
      this.selectedFees = selection;
    },

    // 确认添加选中的费用
    confirmAddFees() {
      if (this.selectedFees.length === 0) {
        this.$message.warning("请选择需要添加的费用");
        return;
      }

      // 将选中的费用返回给父组件
      this.$emit("selected", this.selectedFees);
      this.dialogVisible = false;

      // 重置状态以便下次打开
      this.currentView = 'list';
      this.selectedFees = [];
    },
  }
};
</script>

<style scoped lang="less">
.search-form {
  padding: 0 5px; // 添加统一的左右内边距
}

.tableBlock {
  width: 100%;
  padding: 0 5px; // 添加与search-form相同的左右内边距
  margin-bottom: 15px; // 添加底部间距，使表格与分页器之间有合适的间隔
  height: 400px; // 固定表格容器高度

  ::v-deep .el-table {
    width: 100%;
    table-layout: fixed;

    // 设置表格内容区域高度，使其固定且可滚动
    .el-table__body-wrapper {
      height: calc(400px - 32px); // 减少表头高度为32px
      overflow-y: auto;
    }

    // 进一步减少表头高度
    th.el-table__cell {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 500;
      text-align: center;
      padding: 4px 0; // 从8px减少到4px
      height: 32px; // 从40px减少到32px
      line-height: 20px; // 从24px减少到20px
      font-size: 12px; // 减小表头字体大小
    }

    // 大幅减少表格内容行高
    td.el-table__cell {
      text-align: center;
      padding: 2px 0; // 从4px减少到2px
      height: 28px; // 从36px减少到28px
      line-height: 24px; // 从28px减少到24px
      font-size: 12px; // 减小内容字体大小
    }

    // 进一步优化表格内容显示
    .cell {
      line-height: 1; // 从1.2减少到1
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 5px; // 减少左右内边距
      padding-right: 5px;
      white-space: nowrap; // 防止文字换行
    }

    // 缩小按钮
    .el-button--text {
      padding: 0; // 移除按钮内边距
      font-size: 12px; // 减小按钮字体大小
    }
  }
}

.paginationBlock {
  margin-top: 20px;
  text-align: right;
  padding: 0 5px; // 保持与上面元素相同的左右间距
}

.fee-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.fee-content {
  width: 100%;
  padding: 0 5px; // 添加与search-form相同的左右内边距
  margin-bottom: 15px; // 添加底部间距

  ::v-deep .el-table {
    width: 100%;
    table-layout: fixed;

    // 表格样式与订单列表一致
    .el-table__body-wrapper {
      height: calc(400px - 28px); // 从32px减少到28px
      overflow-y: auto;
    }

    th.el-table__cell {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 500;
      text-align: center;
      padding: 4px 0; // 增加padding
      height: 32px; // 增加表头高度
      line-height: 20px;
      font-size: 12px;
    }

    // 大幅减少表格内容行高
    td.el-table__cell {
      text-align: center;
      padding: 2px 0; // 从4px减少到2px
      height: 28px; // 从36px减少到28px
      line-height: 24px; // 从28px减少到24px
      font-size: 12px; // 减小内容字体大小
    }

    // 进一步优化表格内容显示
    .cell {
      line-height: 1; // 从1.2减少到1
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 5px; // 减少左右内边距
      padding-right: 5px;
      white-space: nowrap; // 防止文字换行
    }


    // 更进一步优化复选框
    .el-checkbox {
      height: 16px; // 增加复选框高度
      margin: 0; 

      .el-checkbox__inner {
        width: 14px; // 增加复选框尺寸
        height: 14px;

        &::after {
          height: 6px;
          width: 2px;
          left: 4px;
          top: 1px;
        }
      }

      .el-checkbox__label {
        padding-left: 4px;
        font-size: 0;
      }
    }

    // 增加表格行高
    .el-table__row {
      height: 32px; // 增加行高
    }
  }
}

.dialog-footer {
  text-align: right;
  margin-top: 15px;
}

.order-search-dialog ::v-deep .el-dialog__body {
  position: relative;
  overflow: visible;
}
.order-search-dialog ::v-deep .el-select {
  position: relative;
}
.order-search-dialog ::v-deep .order-search-popper {
  position: absolute !important;
  left: 0 !important;
  top: calc(100% + 4px) !important;
  transform: none !important;
  min-width: 100% !important;
}
</style>
